import { EventEmitter, Output } from '@angular/core';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

export abstract class DialogBaseComponent {

  @Output() closeDialog: any = new EventEmitter();
  @Output() nextDialog: any = new EventEmitter();
  protected redCross;

  constructor(popupName: String, redCrossService: AnalyticsTrackingProvider, triggerRedCrossEvent = true) {
    this.redCross = redCrossService;
    if (triggerRedCrossEvent) {
      redCrossService.track(REDCRSS_EVENTS.POPUP_SHOWN, {
        popupName: popupName
      });
    }
  }

  close() {
    this.closeDialog.emit();
  }
}
